import { Box, Colors, InputV2, Text } from '@pinchenterprisesnpm/friday-ui'
import { SectionItem } from '@src/features/shift-post-v2/components'
import { connect, FormikProps } from 'formik'
import { ShiftPostPage } from '@src/features/shift-post-v2/pages'
import { useModal } from '@src/hooks/useModal'
import { CustomValidationError } from '@src/ui/components/common/style'
import { ShiftPostStep } from '../../..'
import { EditNumberModal } from './edit-numbers-modal'

interface IShiftIdentifierNumbersSectionProps {
  formik?: FormikProps<IShiftIdentifierNumbersSectionFormValues>
  sourceStep: ShiftPostStep
  sourcePage: ShiftPostPage
}

export interface IShiftIdentifierNumbersSectionFormValues {
  gig_identifier: string
}

export const ShiftIdentifierNumbersSection = connect<IShiftIdentifierNumbersSectionProps>(
  ({ formik, sourceStep }) => {
    const { values, setFieldValue, errors } = formik
    const isConfirmStep = sourceStep === ShiftPostStep.CONFIRM
    const [isOpen, toggleModal, closeModal] = useModal()

    return (
      <SectionItem title='Shift Identifier Numbers' hasEdit={isConfirmStep} onEdit={toggleModal}>
        <Box>
          {isConfirmStep ? (
            <>
              <Text fontSize='medium' mt='xs' mb='xs' color={Colors.dark}>
                {values.gig_identifier || 'You have not entered any shift identifier numbers yet.'}
              </Text>
              <CustomValidationError>{errors.gig_identifier}</CustomValidationError>
            </>
          ) : (
            <Box mt='sm'>
              <InputV2
                label='Shift Identifier Numbers'
                name='gig_identifier'
                id='gig_identifier'
                value={values.gig_identifier || ''}
                onChange={(e) => setFieldValue('gig_identifier', e.target.value)}
                errorMessage={errors.gig_identifier}
              />
            </Box>
          )}
        </Box>

        <EditNumberModal isOpen={isOpen} closeModal={closeModal} />
      </SectionItem>
    )
  }
)
